import { Stack, Typography } from "@mui/material";
import { Link, Outlet, useLocation } from "react-router-dom";
import ProtectedRoute from "../../routing/ProtectedRoute";
import { ReactNode, useMemo } from "react";
import ErrorBoundary from "../../common/ErrorBoundary";
import { startCase } from "lodash";
import { useAuth } from "../../../context/AuthContext";
import { BreadcrumbsContainer, BreadcrumbsContextProvider } from "@components/custom-components/breadcrumbs/BreadcrumbsContext";

const ParentLayout = ({ children }: { children?: ReactNode }) => {
  const { pathname } = useLocation();
  const { baseRole: role } = useAuth();

  const isIDPath = (path: string) => {
    const guidRegex = /^\{?[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}\}?$/;
    return !guidRegex.test(path) && isNaN(Number(path));
  };

  const locations = useMemo(() => pathname?.split("/").filter(isIDPath), [pathname]);

  return (
    <ProtectedRoute>
      <BreadcrumbsContextProvider>
        <Stack p={3}>
          <BreadcrumbsContainer>
            {!locations?.slice(1)?.length && (
              <Link color="inherit" to="/">
                <Typography variant="breadcrumbs">
                  {`${startCase(role || "")} Dashboard`}
                </Typography>
              </Link>
            )}
            {locations?.slice(1).map((l, index) => (
              <Link
                key={index}
                color="inherit"
                to={`/${locations?.join("/")}`}
              >
                <Typography variant="breadcrumbs">
                  {startCase(l)}
                </Typography>
              </Link>
            ))}
          </BreadcrumbsContainer>

          <ErrorBoundary resetKey={pathname}>
            {children}
            <Outlet />
          </ErrorBoundary>
        </Stack>
      </BreadcrumbsContextProvider>
    </ProtectedRoute>
  );
};

export default ParentLayout;
